export class SPSAOPerationViewReq{
    operation : string

    constructor(operation : string){
        this.operation = operation
    }
}